import { render, staticRenderFns } from "./modalHoldVideo.vue?vue&type=template&id=5f6d2927&scoped=true&"
import script from "./modalHoldVideo.vue?vue&type=script&lang=js&"
export * from "./modalHoldVideo.vue?vue&type=script&lang=js&"
import style0 from "./modalHoldVideo.vue?vue&type=style&index=0&id=5f6d2927&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6d2927",
  null
  
)

export default component.exports